var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorLayout',{attrs:{"btnTexto":_vm.btnTexto,"showBtn":_vm.showBtn,"svgNome":_vm.imagemUrl,"texto":_vm.texto,"titulo":_vm.titulo},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }